/* eslint-disable @typescript-eslint/camelcase */
import intl from 'react-intl-universal'

import * as initialLoad from '../routes/initialLoads'
import { setPicklists } from '~/redux/picklistsReducer'

function picklistService(toastr, settingsService, $q, $ngRedux) {
  this._picklists_set = false // Old-school cool
  this.picklists = {}
  this._afterPicklistSetHandlers = []
  this.afterPicklistSet = (callback, priority = 0) => {
    let idx = 0
    for (idx; idx < this._afterPicklistSetHandlers.length; idx++) {
      const handler = this._afterPicklistSetHandlers[idx]
      if (handler[0] === callback) {
        return true
      }
    }
    this._afterPicklistSetHandlers.push([callback, priority])
    this._afterPicklistSetHandlers.sort(function (alpha, bravo) {
      if (alpha[1] === bravo[1]) {
        return 0
      }
      if (alpha[1] > bravo[1]) {
        return -1
      }
      return 1
    })
    return true
  }
  this.procPicklistSetCallbacks = (payload) => {
    let idx = 0
    for (idx; idx < this._afterPicklistSetHandlers.length; idx++) {
      const handler = this._afterPicklistSetHandlers[idx]
      handler[0]({
        priority: handler[1],
        payload: payload,
      })
    }
  }
  this.set = (picklists) => {
    this._picklists_set = true
    this.picklists = picklists
    $ngRedux.dispatch(setPicklists(picklists))
    this.procPicklistSetCallbacks(picklists)
  }
  this.get = () => {
    if (!this._picklists_set) {
      return initialLoad.picklist
    }
    return this.picklists
  }
  this.obtain = (key) => {
    if (!this._picklists_set) {
      return initialLoad.picklist
    }
    if (!Object.prototype.hasOwnProperty.call(this.picklists.picklists, key)) {
      return null
    }
    return this.picklists.picklists[key]
  }
  this.validate = (picklist) => {
    const valid = picklist.picklist.reduce(
      (acc, p) => {
        if (acc.text.indexOf(p.text) > -1 || acc.id.indexOf(p.id) > -1) {
          acc.dupe = true
        }

        if (p.text === '' || p.id === '') {
          acc.empty = true
        }

        return {
          ...acc,
          text: [...acc.text, p.text],
          id: [...acc.id, p.id],
        }
      },
      { text: [], id: [], empty: false, dupe: false }
    )
    if (valid.empty) {
      toastr.error(intl.get('picklistService.validate.empty'))
      return false
    }
    if (valid.dupe) {
      toastr.error(intl.get('picklistService.validate.dupe'))
      return false
    }
    return true
  }
  this.applyRenderType = (preSaveData, picklistId, renderType) => {
    // Only care about the one, right now. A refactor will have to happen in order to get the rest.
    preSaveData.picklists[picklistId].renderType = renderType
    return preSaveData
  }
  this.preSave = (picklistId, picklists, picklist, orderType) => ({
    picklists: Object.keys({
      ...picklists,
      [picklistId]: picklist,
    }).reduce((acc, k) => {
      return k !== picklistId
        ? { ...acc, [k]: picklists[k] }
        : {
            ...acc,
            [picklistId]: {
              orderType: orderType,
              picklist: picklist.picklist.map((p) => ({
                id: p.id,
                text: p.text,
                order: p.order,
                active: p.active,
                default: p.default,
              })),
            },
          }
    }, {}),
  })
  this.addToPicklistStructureButDontPersistYet = (entry, key) => {
    // Avoid Mutation at all costs until the backend is updated!
    if (!this._picklists_set) {
      return initialLoad.picklist
    }
    const picklist = this.picklists.picklists[key].picklist.slice()
    picklist.push(entry)
    return {
      picklist: picklist,
      orderType: this.picklists.picklists[key].orderType,
    }
  }
  this.commit = (data) => {
    const defer = $q.defer()
    settingsService
      .saveCompanySettings('picklists', data)
      .then((...args) => {
        toastr.info(intl.get('picklistService.commit.created'))
        defer.resolve(data, args)
      })
      .catch(() => toastr.error(intl.get('picklistService.commit.error')))
    return defer.promise
  }
  this.loadRenderingOptions = () => {
    const defer = $q.defer()
    // settingsService
    //   .fetchSettings('picklistRendering'
    //   .saveCompanySettings(
    return defer.promise
  }
}

export default ['toastr', 'settingsService', '$q', '$ngRedux', picklistService]
